import IframeResizer from '@rio-cloud/iframe-resizer';
import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';

type ContactDialogProps = {
    show: boolean;
    onClose: () => void;
};

export const ContactDialog = ({ show, onClose }: ContactDialogProps) => {
    const dialogTrackingKey = 'ordercom.contact-dialog';
    return (
        <Dialog
            title={'Contact'}
            show={show}
            showCloseButton={false}
            onClose={onClose}
            useOverflow
            bodyClassName={'min-height-500'}
            headerButtons={
                <Button
                    bsStyle={Button.MUTED}
                    iconOnly
                    iconName='remove'
                    autoTrackingKey={`${dialogTrackingKey}.close`}
                    className='modal-header-close close'
                    onClick={onClose}
                    aria-label='dialog close button'
                />
            }
            body={
                <IframeResizer
                    title='Contact'
                    src={`https://contact-form.rio.cloud/contact?hideTitle=true&opener=${window.location.host}`}
                    allowedOrigins='any'
                    className='unstyled min-width-100pct'
                    style={{ height: '600px' }}
                />
            }
        />
    );
};
